import api from "../../../Component/axios";

export const usePedidoEmpaque = () => {
  const token = localStorage.getItem("@Token");

  const postPedidoEmpaque = async (data, id_programacion) => {
    try {
      await api.post(
        "api/programacion/pedido/",
        { data, id_programacion },
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return { postPedidoEmpaque };
};
